import { render, staticRenderFns } from "./search-no-results.vue?vue&type=template&id=fe3d054a&scoped=true"
import script from "./search-no-results.vue?vue&type=script&lang=js"
export * from "./search-no-results.vue?vue&type=script&lang=js"
import style0 from "./search-no-results.vue?vue&type=style&index=0&id=fe3d054a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3d054a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/var/www/tubber-new/components/global/v/button.vue').default,VImg: require('/var/www/tubber-new/components/global/v/img.vue').default})
